import { FC, useState } from 'react';
import { Typography, Grid, IconButton, Tooltip } from '@mui/material';
import { useAppDispatch } from '../../../hooks';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { fetchSitesStockPdf, fetchSitesStockExcel } from './Services';
import { showAlertAction } from '../../../store/alerts';
import { Search } from '../../../../src/components';
export const circleButtonSize = '32px';
export const circleIconSize = '18px';

interface SitesStockSummaryHeaderProps {
  searchString: string;
  setSearchString: (value: string) => void;
  onPdfClick: () => void
  partyId?: string
}

const SitesStockSummaryHeader: FC<SitesStockSummaryHeaderProps> = ({
  searchString,
  setSearchString,
  onPdfClick,
  partyId
}) => {
  const [isEnabled, setIsEnabled] = useState(true);

  const dispatchAction = useAppDispatch();
  const fetchPDF = () => {
    setIsEnabled(false);
    fetchSitesStockPdf(partyId).then((response) => {
      setIsEnabled(true);
      if (response.success) {
        window.open(response.data, '_blank');
      } else {
        dispatchAction(
          showAlertAction({
            message: response.message,
            severity: 'error',
          })
        );
      }
    });
  };

  const fetchExcel = () => {
    setIsEnabled(false);
    fetchSitesStockExcel(partyId).then((response) => {
      setIsEnabled(true);
      if (response.success) {
        window.open(response.data, '_blank');
      } else {
        dispatchAction(
          showAlertAction({
            message: response.message,
            severity: 'error',
          })
        );
      }
    });
  };

  return (
    <>
      <Grid container alignItems="stretch">
        <Grid item md={5}>
          <Typography variant="h3" component="h3" gutterBottom>
            Party Wise Pending Items
          </Typography>
        </Grid>

       

        <Grid
          md={3}
          item
          sx={{ textAlign: 'right', display: 'flex', justifyContent: 'right', alignItems: 'center' }}
        >
          <Tooltip title="Export Excel">
            <IconButton
              disabled={!isEnabled}
              onClick={fetchExcel}
              sx={{
                mr: 1.25,
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
                color: 'white',
                width: circleButtonSize,
                height: circleButtonSize,
                minWidth: circleButtonSize,
                minHeight: circleButtonSize,
                maxWidth: circleButtonSize,
                maxHeight: circleButtonSize,
                borderRadius: '50%',
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography sx={{ fontSize: circleIconSize, fontWeight: 'bold', lineHeight: 1 }}>xl</Typography>
            </IconButton>
          </Tooltip>
          <Tooltip title="Export PDF">
            <IconButton
              disabled={!isEnabled}
              onClick={fetchPDF}
              sx={{
                mr: 2,
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
                color: 'white',
                width: circleButtonSize,
                height: circleButtonSize,
                minWidth: circleButtonSize,
                minHeight: circleButtonSize,
                maxWidth: circleButtonSize,
                maxHeight: circleButtonSize,
                borderRadius: '50%',
                padding: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <PictureAsPdfIcon sx={{ width: circleIconSize, height: circleIconSize }} />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid
          item
          md={4}
          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
        >
           <Search onSearch={setSearchString} value={searchString} />
        
        </Grid>
      </Grid>
    </>
  );
};

export default SitesStockSummaryHeader;
